import Policy from './index';

const routesPolicy = [
  {
    path: '/policy',
    component: Policy,
  },
];

export default routesPolicy;
